import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';


import { AddWarrantyServiceModel } from '../models/warrantyService/warrantyService.model';
import { UrlHelperService } from './Common/urlhelper.service';

import { LocalstorageService } from './Common/localstorage.service';
import { ApiService } from './Common/api.service';
import { UpdateProductWarrantyService } from '../models/product/updateProductWarrantyService.modal';
import { ProductWarrantyItemList, WarrantyDetailsModel } from '../models/product/productAssets.modal';
import { BehaviorSubject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class WarrantyServiceService {

  checkBoxSubject$ = new BehaviorSubject<boolean>(null);

  constructor(private _api: ApiService, private httpClient: HttpClient, private localStorage: LocalstorageService) { }
  
  WarrantyService(warrantyservice: AddWarrantyServiceModel) {    
    return this._api.post(UrlHelperService.addWarrantyService, warrantyservice)
  }

  WarrantyServiceListing(){
    return this._api.get(UrlHelperService.warrantyServiceListing);
}

getWarrantyServiceId(id) {
  return this._api.post(UrlHelperService.getWarrantyServicebyid + id);
}

updateWarrantyService(updateWarrantyService: AddWarrantyServiceModel) {
  return this._api.post(UrlHelperService.updatewarrantyservice + updateWarrantyService.Id , updateWarrantyService);
}

updateProductWarrantyService(updateProductWarrantyService: UpdateProductWarrantyService) {
  return this._api.post(UrlHelperService.updateproductwarrantyservice, updateProductWarrantyService);
}
  
getProductWarrantyServiceId(productId) {
  return this._api.post(UrlHelperService.getproductWarrantyServicebyid + productId);
}

AddProductWarrantyService(warrantyServiceItem: ProductWarrantyItemList) {
  return this._api.post(UrlHelperService.addProductWarrantyService + warrantyServiceItem.warrantyId, warrantyServiceItem)
}

ProductWarrantyServiceList(warrantyServiceItemModel: WarrantyDetailsModel) {
  return this._api.post(UrlHelperService.ProductWarrantyServiceDetails + warrantyServiceItemModel.warrantyId, warrantyServiceItemModel)
}
}
